import DayJSAdapter from '@date-io/dayjs';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import 'vuetify/styles';

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    ssr: true,
    date: {
      adapter: DayJSAdapter,
    },

    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            'text-primary': '#292725',
            'text-secondary': '#565453',
            'text-tertiary': '#8E8D8C',
            'text-disabled': '#BCBBBA',
            'text-inverted': '#FFFFFF',
            'text-white': '#FFFFFF',
            'text-brand-default': '#00A8B5',
            // background: '#FFFFFF',
            // surface: '#FFFFFF',
            'background-top-nav': '#1D1B19',
            'background-body': '#F4F4F4',
            'surface-background': '#FFFFFF',
            'surface-background-2': '#F7F7F9',
            'surface-background-3': '#E6E6EA',
            'surface-field': '#F2F2F4',
            'surface-tag': '#F2F2F4',
            'surface-disabled': '#BCBBBA',
            'surface-inverted': '#292725',
            'surface-brand-default': '#00A8B5',
            'surface-brand-shade-01': '#4CC2CB',
            'surface-brand-shade-02': '#E5F6F7',
            'surface-brand-shade-03': '#F2FBFB',

            'border-default': '#E6E6EA',
            'border-disabled': '#F2F2F4',
            'border-secondary': '#565453',
            'border-ring': '#E5E5E5',
            'border-brand-default': '#00A8B5',
            'border-brand-inverted': '#FFFFFF',

            'icon-default': '#292725',
            'icon-secondary': '#565453',
            'icon-tertiary': '#8E8D8C',
            'icon-disabled': '#BCBBBA',
            'icon-inverted': '#FFFFFF',
            'icon-white': '#FFFFFF',
            'icon-brand-default': '#00A8B5',

            'complimentary-default': '#53CE57',
            'complimentary-shade-01': '#87DD89',
            'complimentary-shade-02': '#EEFAEE',
            'complimentary-shade-03': '#F6FDF7',

            primary: '#292725',
            brand: '#00A8B5',
            secondary: '#565453',
            'on-secondary': '#00A8B5',
            'on-surface-brand-shade-02': '#00A8B5',
            'dark-button': '#292d32',
            // 'primary-1': '#1135B3',
            // 'primary-2': '#E7EDFF',
            // 'primary-3': '#F3F6FF',

            success: '#458C03',
            warning: '#FFA722',
            error: '#F10021',
            info: '#0093C9',

            'semantic-success-shade': '#F9FFF3',
            'semantic-info-shade': '#F2FBFF',
            'semantic-warning-shade': '#FFF9F1',
            'semantic-error-shade': '#FFF4F6',

            disabled: '#CECECE',
            '-primary': '#0A0A0A',
            '-secondary': '#474747',
            '-tertiary': '#848484',
          },
        },
      },
    },
    defaults: {
      global: {
        ripple: false,
      },
      VBtn: {
        rounded: 'lg',
        class: 'text-capitalize',
        flat: true,
      },
      VTextField: {
        class: 'bordered-input',
      },
    },
  });

  nuxtApp.vueApp.use(vuetify);
});
